import { useEffect, useState } from 'react';
import { contactPageService } from '@/api/services';
import { resolveSiteBuilderIconComponent } from '@/utils/siteBuilderIconMap';

function mapContactSections(sectionsData) {
  return (Array.isArray(sectionsData) ? sectionsData : []).map((sec) => ({
    ...sec,
    items: sec.items?.map((item) => ({
      ...item,
      IconComponent: resolveSiteBuilderIconComponent(item.icon)
    })) || []
  }));
}

export const useContactPage = (sectionKey = null, initialSections = null) => {
  const [sections, setSections] = useState(() => (initialSections != null && !sectionKey ? mapContactSections(initialSections) : []));
  const [section, setSection] = useState(null);
  const [loading, setLoading] = useState(!(initialSections != null && !sectionKey));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (initialSections != null && !sectionKey) {
      setSections(mapContactSections(initialSections));
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        if (sectionKey) {
          const response = await contactPageService.getSectionByKey(sectionKey);
          if (response.data?.success) {
            const sectionData = response.data.data;
            if (sectionData.items) {
              sectionData.items = sectionData.items.map((item) => ({
                ...item,
                IconComponent: resolveSiteBuilderIconComponent(item.icon)
              }));
            }
            setSection(sectionData);
          }
        } else {
          const response = await contactPageService.getAllSections();
          if (response.data?.success) {
            setSections(mapContactSections(response.data.data || []));
          }
        }
      } catch (err) {
        console.error('Error fetching contact page data:', err);
        setError(err.message || 'Failed to load contact page data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [sectionKey, initialSections]);

  return { sections, section, loading, error };
};

export default useContactPage;
